var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useMemo, useState } from "react";
import { ClockIcon, HomeIcon, LockClosedIcon, PersonIcon, Pencil2Icon, StarIcon, StarFilledIcon, } from "@radix-ui/react-icons";
import { Card } from "../card";
import { useAuth, useCart, useUI } from "../../providers";
import { RadixButton } from "../primitives/RadixButton";
import { ResponsiveContainer } from "../responsiveContainer";
import { EditAddressFlyOut } from "../editAddressFlyOut";
import { OrderReviewFlyOut } from "../orderReviewFlyOut";
import { AccountAccordion } from "../accountAccordion";
import "./userAccountArea.css";
import { formatCurrency } from "../utility/formatCurrency";
import { UserAccountManagementFlyOut } from "../userAccountManagementFlyOut";
import { RadixAlertDialogue } from "../primitives/RadixAlertDialogue";
import { StateInitializationLoading } from "../stateInitializationLoading";
import { DeleteIcon, EyeIcon, RefreshIcon } from "../icons";
export var UserAccountArea = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var repeatOrder = useCart().repeatOrder;
    var _h = useAuth(), user = _h.user, isAuthenticated = _h.isAuthenticated, hasResolvedAuthState = _h.hasResolvedAuthState, history = _h.history, updateAddress = _h.updateAddress, deleteAddress = _h.deleteAddress, deleteSavedCard = _h.deleteSavedCard, updateUserProfile = _h.updateUserProfile, deleteUserAccount = _h.deleteUserAccount;
    var _j = useUI(), openSignInModal = _j.openSignInModal, editAddressFlyoutIsOpen = _j.editAddressFlyoutIsOpen, openEditAddressFlyout = _j.openEditAddressFlyout, closeEditAddressFlyout = _j.closeEditAddressFlyout, deleteConfirmationModalIsOpen = _j.deleteConfirmationModalIsOpen, openDeleteConfirmationModal = _j.openDeleteConfirmationModal, closeDeleteConfirmationModal = _j.closeDeleteConfirmationModal, setDeleteConfirmationModalIsOpen = _j.setDeleteConfirmationModalIsOpen, showToast = _j.showToast;
    var _k = useState(null), editingAddressId = _k[0], setEditingAddressId = _k[1];
    var _l = useState(false), isSubmittingAddress = _l[0], setIsSubmittingAddress = _l[1];
    var _m = useState(null), defaultAddressActionId = _m[0], setDefaultAddressActionId = _m[1];
    var _o = useState(null), pendingDeleteAction = _o[0], setPendingDeleteAction = _o[1];
    var _p = useState(""), deleteConfirmationText = _p[0], setDeleteConfirmationText = _p[1];
    var _q = useState(null), isRepeatingOrder = _q[0], setIsRepeatingOrder = _q[1];
    var _r = useState(null), selectedOrder = _r[0], setSelectedOrder = _r[1];
    var _s = useState(false), isOrderReviewOpen = _s[0], setIsOrderReviewOpen = _s[1];
    var _t = useState(false), isAccountManagementOpen = _t[0], setIsAccountManagementOpen = _t[1];
    var _u = useState(false), isSubmittingAccountDetails = _u[0], setIsSubmittingAccountDetails = _u[1];
    var _v = useState(false), isDeletingAccount = _v[0], setIsDeletingAccount = _v[1];
    var _w = useState({
        rewards: false,
        orders: false,
        addresses: false,
        payments: false,
    }), expandedSections = _w[0], setExpandedSections = _w[1];
    var offers = Array.isArray(history === null || history === void 0 ? void 0 : history.offers) ? history.offers : [];
    var addresses = Array.isArray(history === null || history === void 0 ? void 0 : history.addresses) ? history.addresses : [];
    var savedCards = Array.isArray(history === null || history === void 0 ? void 0 : history.saved_cards) ? history.saved_cards : [];
    var orders = Array.isArray(history === null || history === void 0 ? void 0 : history.orders) ? history.orders : [];
    var storeCreditProcessor = String((_c = (_b = (_a = window.session) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.credit_processor) !== null && _c !== void 0 ? _c : "").toLowerCase();
    var supportsSavedPaymentMethods = ["arrowpay", "shift4", "xplorpay"].includes(storeCreditProcessor);
    var savedCardsForProcessor = savedCards.filter(function (card) { var _a; return String((_a = card.credit_processor) !== null && _a !== void 0 ? _a : "").toLowerCase() === storeCreditProcessor; });
    var hasSavedPaymentMethods = savedCardsForProcessor.length > 0;
    var formatOrderDate = function (value) {
        if (!value) {
            return "Unknown date";
        }
        var parsedDate = new Date(value);
        if (Number.isNaN(parsedDate.getTime())) {
            return "Unknown date";
        }
        return parsedDate.toLocaleDateString();
    };
    var isOfferExpired = function (expirationValue) {
        var rawExpiration = String(expirationValue || "").trim();
        if (!rawExpiration) {
            return false;
        }
        var parsedExpiration = new Date(rawExpiration);
        if (Number.isNaN(parsedExpiration.getTime())) {
            return false;
        }
        parsedExpiration.setHours(23, 59, 59, 999);
        return parsedExpiration.getTime() < Date.now();
    };
    var availableOffers = useMemo(function () {
        var seenPromoCodes = new Set();
        return offers
            .filter(function (offer) {
            return !isOfferExpired(offer.ExpDate);
        })
            .filter(function (offer) {
            var normalizedPromoCode = String(offer.PromoCode || "").trim().toLowerCase();
            if (!normalizedPromoCode) {
                return true;
            }
            if (seenPromoCodes.has(normalizedPromoCode)) {
                return false;
            }
            seenPromoCodes.add(normalizedPromoCode);
            return true;
        });
    }, [offers]);
    var hasRewardsAccount = useMemo(function () {
        if (!user) {
            return false;
        }
        var rawRewardsValue = user.uses_rewards;
        if (typeof rawRewardsValue === "boolean") {
            return rawRewardsValue;
        }
        if (typeof rawRewardsValue === "number") {
            return rawRewardsValue === 1;
        }
        if (typeof rawRewardsValue === "string") {
            var normalizedRewardsValue = rawRewardsValue.trim().toLowerCase();
            return normalizedRewardsValue === "1" || normalizedRewardsValue === "true";
        }
        return false;
    }, [user]);
    var displayName = useMemo(function () {
        var _a, _b;
        var firstName = String((_a = user === null || user === void 0 ? void 0 : user.first_name) !== null && _a !== void 0 ? _a : "").trim();
        var lastName = String((_b = user === null || user === void 0 ? void 0 : user.last_name) !== null && _b !== void 0 ? _b : "").trim();
        return [firstName, lastName].filter(Boolean).join(" ") || "Guest";
    }, [user]);
    var isDefaultAddress = function (rawValue) {
        if (typeof rawValue === "boolean") {
            return rawValue;
        }
        if (typeof rawValue === "number") {
            return rawValue === 1;
        }
        if (typeof rawValue === "string") {
            var normalizedValue = rawValue.trim().toLowerCase();
            return normalizedValue === "1" || normalizedValue === "true";
        }
        return false;
    };
    var resetAddressEditState = function () {
        setEditingAddressId(null);
    };
    var handleOpenAddressEditor = function (addressId) {
        var addressToEdit = addresses.find(function (address) { return String(address.id) === String(addressId); });
        if (!addressToEdit) {
            return;
        }
        setEditingAddressId(addressId);
        openEditAddressFlyout();
    };
    var handleAddressFlyoutOpenChange = function (open) {
        if (!open) {
            closeEditAddressFlyout();
            resetAddressEditState();
            return;
        }
        openEditAddressFlyout();
    };
    var handleDeleteAccount = function () { return __awaiter(void 0, void 0, void 0, function () {
        var wasDeleted;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isDeletingAccount) {
                        return [2 /*return*/];
                    }
                    setIsDeletingAccount(true);
                    return [4 /*yield*/, deleteUserAccount()];
                case 1:
                    wasDeleted = _a.sent();
                    setIsDeletingAccount(false);
                    if (!wasDeleted) {
                        showToast("Unable to delete account.", "error");
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleAddressUpdate = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var wasUpdated;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!editingAddressId || isSubmittingAddress) {
                        return [2 /*return*/];
                    }
                    setIsSubmittingAddress(true);
                    return [4 /*yield*/, updateAddress({
                            addressId: editingAddressId,
                            address: values.address,
                            address2: (_a = values.address2) !== null && _a !== void 0 ? _a : "",
                            city: values.city,
                            state: values.state,
                            zip: values.zip,
                        })];
                case 1:
                    wasUpdated = _b.sent();
                    setIsSubmittingAddress(false);
                    if (wasUpdated) {
                        closeEditAddressFlyout();
                        resetAddressEditState();
                        showToast("Address updated.", "success");
                        return [2 /*return*/];
                    }
                    showToast("Unable to update address.", "error");
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSetAddressAsDefault = function (addressId) { return __awaiter(void 0, void 0, void 0, function () {
        var addressToUpdate, wasUpdated;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (defaultAddressActionId) {
                        return [2 /*return*/];
                    }
                    addressToUpdate = addresses.find(function (address) { return String(address.id) === String(addressId); });
                    if (!addressToUpdate) {
                        showToast("Unable to set default address.", "error");
                        return [2 /*return*/];
                    }
                    if (!addressToUpdate.address || !addressToUpdate.city || !addressToUpdate.state || !addressToUpdate.zip) {
                        showToast("This address is missing required details. Please edit it first.", "error");
                        return [2 /*return*/];
                    }
                    if (isDefaultAddress(addressToUpdate.is_default)) {
                        return [2 /*return*/];
                    }
                    setDefaultAddressActionId(addressId);
                    return [4 /*yield*/, updateAddress({
                            addressId: addressId,
                            address: String(addressToUpdate.address),
                            address2: String((_a = addressToUpdate.address2) !== null && _a !== void 0 ? _a : ""),
                            city: String(addressToUpdate.city),
                            state: String(addressToUpdate.state),
                            zip: String(addressToUpdate.zip),
                            isDefault: true,
                        })];
                case 1:
                    wasUpdated = _b.sent();
                    setDefaultAddressActionId(null);
                    if (wasUpdated) {
                        showToast("Default address updated.", "success");
                        return [2 /*return*/];
                    }
                    showToast("Unable to set default address.", "error");
                    return [2 /*return*/];
            }
        });
    }); };
    var toggleSection = function (sectionKey) {
        setExpandedSections(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[sectionKey] = !prev[sectionKey], _a)));
        });
    };
    var openDeleteModal = function (action) {
        setDeleteConfirmationText(action.deleteText);
        setPendingDeleteAction(action);
        openDeleteConfirmationModal();
    };
    var closeDeleteModal = function () {
        setDeleteConfirmationText("");
        setPendingDeleteAction(null);
        closeDeleteConfirmationModal();
    };
    var handleDeleteConfirmed = function () { return __awaiter(void 0, void 0, void 0, function () {
        var wasDeleted;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    wasDeleted = false;
                    if (!(pendingDeleteAction.type === "address")) return [3 /*break*/, 2];
                    return [4 /*yield*/, deleteAddress(pendingDeleteAction.id)];
                case 1:
                    wasDeleted = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!(pendingDeleteAction.type === "card")) return [3 /*break*/, 4];
                    return [4 /*yield*/, deleteSavedCard(pendingDeleteAction.id)];
                case 3:
                    wasDeleted = _a.sent();
                    _a.label = 4;
                case 4:
                    if (wasDeleted) {
                        closeDeleteModal();
                        showToast("Item successfully deleted.", "success");
                        return [2 /*return*/];
                    }
                    showToast("Unable to delete item.", "error");
                    return [2 /*return*/];
            }
        });
    }); };
    var handleViewOrderDetails = function (order) {
        setSelectedOrder(order);
        setIsOrderReviewOpen(true);
    };
    var handleOrderFlyOutOpenChange = function (open) {
        setIsOrderReviewOpen(open);
        if (!open) {
            setSelectedOrder(null);
        }
    };
    var handleRepeatOrder = function (order) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(order === null || order === void 0 ? void 0 : order.id) || isRepeatingOrder) {
                        return [2 /*return*/];
                    }
                    setIsRepeatingOrder(order.id);
                    return [4 /*yield*/, repeatOrder(order)];
                case 1:
                    result = _a.sent();
                    setIsRepeatingOrder(null);
                    if (!result.success) {
                        showToast(result.message, "error");
                        return [2 /*return*/];
                    }
                    showToast("Order repeated successfully.", "success");
                    window.setTimeout(function () {
                        window.location.href = "".concat(window.relativeURI(), "/cart");
                    }, 500);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleAccountManagementOpenChange = function (open) {
        setIsAccountManagementOpen(open);
    };
    var handleAccountDetailsUpdate = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var wasUpdated;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isSubmittingAccountDetails) {
                        return [2 /*return*/];
                    }
                    setIsSubmittingAccountDetails(true);
                    return [4 /*yield*/, updateUserProfile({
                            firstName: values.firstName,
                            lastName: values.lastName,
                            email: values.email,
                            phone: values.phone,
                        })];
                case 1:
                    wasUpdated = _a.sent();
                    setIsSubmittingAccountDetails(false);
                    if (wasUpdated) {
                        setIsAccountManagementOpen(false);
                        showToast("Account details updated.", "success");
                        return [2 /*return*/];
                    }
                    showToast("Unable to update account details.", "error");
                    return [2 /*return*/];
            }
        });
    }); };
    var accountManagementDefaultValues = useMemo(function () {
        var _a, _b, _c, _d;
        return ({
            firstName: String((_a = user === null || user === void 0 ? void 0 : user.first_name) !== null && _a !== void 0 ? _a : ""),
            lastName: String((_b = user === null || user === void 0 ? void 0 : user.last_name) !== null && _b !== void 0 ? _b : ""),
            email: String((_c = user === null || user === void 0 ? void 0 : user.email) !== null && _c !== void 0 ? _c : ""),
            phone: String((_d = user === null || user === void 0 ? void 0 : user.phone) !== null && _d !== void 0 ? _d : ""),
        });
    }, [user]);
    var editAddressDefaultValues = useMemo(function () {
        var _a, _b, _c, _d, _e;
        var currentAddress = addresses.find(function (address) { return String(address.id) === String(editingAddressId); });
        return {
            address: String((_a = currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.address) !== null && _a !== void 0 ? _a : ""),
            address2: String((_b = currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.address2) !== null && _b !== void 0 ? _b : ""),
            city: String((_c = currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.city) !== null && _c !== void 0 ? _c : ""),
            state: String((_d = currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.state) !== null && _d !== void 0 ? _d : ""),
            zip: String((_e = currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.zip) !== null && _e !== void 0 ? _e : ""),
        };
    }, [addresses, editingAddressId]);
    if (!hasResolvedAuthState) {
        return (React.createElement(ResponsiveContainer, null,
            React.createElement(StateInitializationLoading, { label: "Loading account details" })));
    }
    if (!isAuthenticated) {
        return (React.createElement(ResponsiveContainer, null,
            React.createElement(Card, { className: "user-account-signin-card mt-3" },
                React.createElement("h1", { className: "user-account-signin-title" }, "My Account"),
                React.createElement("p", { className: "user-account-p" }, "Please sign in to view your account details."),
                React.createElement(RadixButton, { className: "user-account-signin-button", onClick: openSignInModal }, "Sign in"))));
    }
    return (React.createElement(ResponsiveContainer, null,
        React.createElement("section", { className: "user-account-area", "aria-label": "User account area" },
            hasRewardsAccount ?
                React.createElement(Card, { className: "user-account-hero" },
                    React.createElement("div", { className: "user-account-hero-top" },
                        React.createElement("div", null,
                            React.createElement("h1", null, displayName),
                            React.createElement("p", { className: "user-account-hero-subtitle" }, "Your account overview and loyalty progress.")),
                        React.createElement("div", { className: "user-account-hero-actions" },
                            React.createElement(RadixButton, { className: "user-account-inline-button", onClick: function () { return setIsAccountManagementOpen(true); } },
                                React.createElement(PersonIcon, null),
                                " Manage Account"))),
                    React.createElement("div", { className: "user-account-metrics" },
                        React.createElement("div", { className: "user-account-metric" },
                            React.createElement("span", { "aria-hidden": "true" },
                                React.createElement(StarFilledIcon, { color: "gold", height: 25, width: 25 })),
                            React.createElement("div", null,
                                React.createElement("p", null, "Points"),
                                React.createElement("strong", null, (_d = history === null || history === void 0 ? void 0 : history.current_points) !== null && _d !== void 0 ? _d : "--"))),
                        React.createElement("div", { className: "user-account-metric" },
                            React.createElement("span", { "aria-hidden": "true" },
                                React.createElement(StarFilledIcon, { color: "gold", height: 25, width: 25 })),
                            React.createElement("div", null,
                                React.createElement("p", null, "Points to next offer"),
                                React.createElement("strong", null, (_e = history === null || history === void 0 ? void 0 : history.points_to_next) !== null && _e !== void 0 ? _e : "--")))))
                :
                    React.createElement(Card, { className: "user-account-hero" },
                        React.createElement("div", { className: "user-account-hero-top" },
                            React.createElement("div", null,
                                React.createElement("h1", null, displayName),
                                React.createElement("div", { hidden: ((_g = (_f = window === null || window === void 0 ? void 0 : window.session) === null || _f === void 0 ? void 0 : _f.store) === null || _g === void 0 ? void 0 : _g.rr_enabled) === 0 },
                                    React.createElement("p", { className: "user-account-hero-subtitle" }, "Sign up for rewards to start earning reward points."),
                                    React.createElement("p", { className: "user-account-rewards-disclaimer" }, "By joining rewards, you agree to receive rewards-related messages."))),
                            React.createElement("div", { className: "user-account-hero-actions" },
                                React.createElement(RadixButton, { className: "user-account-inline-button", onClick: function () { return setIsAccountManagementOpen(true); } },
                                    React.createElement(PersonIcon, null),
                                    " Manage Account")))),
            React.createElement("div", { className: "user-account-grid" },
                hasRewardsAccount ?
                    React.createElement(AccountAccordion, { icon: React.createElement("span", { className: "section-icon" },
                            React.createElement(StarIcon, null)), title: "Rewards", isExpanded: expandedSections.rewards, onToggle: function () { return toggleSection("rewards"); } }, availableOffers.length > 0 ? (React.createElement("ul", { className: "user-account-list" }, availableOffers.map(function (offer, index) {
                        var _a, _b, _c, _d, _e;
                        return (React.createElement("li", { key: String((_b = (_a = offer.PK) !== null && _a !== void 0 ? _a : offer.PromoCode) !== null && _b !== void 0 ? _b : index), className: "user-account-list-item" },
                            React.createElement("p", { className: "user-account-list-item-title" },
                                "Code: ", (_c = offer.PromoCode) !== null && _c !== void 0 ? _c : "Offer"),
                            React.createElement("p", { className: "user-account-list-item-copy" }, (_d = offer.Offer) !== null && _d !== void 0 ? _d : "Offer details unavailable."),
                            React.createElement("p", { className: "user-account-list-item-meta" },
                                "Expires: ", (_e = offer.ExpDate) !== null && _e !== void 0 ? _e : "N/A")));
                    }))) : (React.createElement("p", { className: "user-account-empty-copy" }, "No rewards available yet."))) : null,
                React.createElement(AccountAccordion, { icon: React.createElement("span", { className: "section-icon" },
                        React.createElement(ClockIcon, null)), title: "Previous orders", isExpanded: expandedSections.orders, onToggle: function () { return toggleSection("orders"); } }, orders.length > 0 ? (React.createElement("ul", { className: "user-account-list" }, orders.map(function (order, index) {
                    var _a, _b, _c, _d, _e, _f, _g;
                    var orderLineCount = Array.isArray(order.lines) ? order.lines.length : 0;
                    var firstLineName = (_c = (_b = (_a = order.lines) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "Item";
                    return (React.createElement("li", { key: String((_e = (_d = order.id) !== null && _d !== void 0 ? _d : order.reference) !== null && _e !== void 0 ? _e : index), className: "user-account-list-item" },
                        React.createElement("p", { className: "user-account-list-item-title" },
                            "#", (_g = (_f = order.reference) !== null && _f !== void 0 ? _f : order.id) !== null && _g !== void 0 ? _g : "Order",
                            " \u2022 ",
                            formatCurrency(order.total)),
                        React.createElement("p", { className: "user-account-list-item-copy" },
                            orderLineCount,
                            " ",
                            orderLineCount === 1 ? "item" : "items",
                            " \u2022 ",
                            firstLineName,
                            orderLineCount > 1 ? " + more" : ""),
                        React.createElement("p", { className: "user-account-list-item-meta" }, formatOrderDate(order.created_at)),
                        React.createElement("div", { className: "user-account-item-actions" },
                            React.createElement(RadixButton, { className: "user-account-inline-button", onClick: function () { return handleViewOrderDetails(order); } },
                                React.createElement(EyeIcon, null),
                                "View details"),
                            React.createElement(RadixButton, { className: "user-account-inline-button", onClick: function () { return handleRepeatOrder(order); }, disabled: Boolean(isRepeatingOrder) },
                                React.createElement(RefreshIcon, null),
                                isRepeatingOrder === order.id ? "Repeating..." : "Repeat order"))));
                }))) : (React.createElement("p", { className: "user-account-empty-copy" }, "No previous orders yet."))),
                React.createElement(AccountAccordion, { icon: React.createElement("span", { className: "section-icon" },
                        React.createElement(HomeIcon, null)), title: "Previous addresses", isExpanded: expandedSections.addresses, onToggle: function () { return toggleSection("addresses"); } }, addresses.length > 0 ? (React.createElement("ul", { className: "user-account-list" }, addresses.map(function (address) {
                    var _a;
                    var addressId = String((_a = address.id) !== null && _a !== void 0 ? _a : "");
                    var defaultAddress = isDefaultAddress(address.is_default);
                    return (React.createElement("li", { key: addressId, className: "user-account-list-item" },
                        React.createElement("p", { className: "user-account-list-item-copy" }, [address.address, address.address2].filter(Boolean).join(" ")),
                        React.createElement("p", { className: "user-account-list-item-meta" }, [address.city, address.state, address.zip].filter(Boolean).join(", ")),
                        defaultAddress ? (React.createElement("p", { className: "user-account-default-address-label" },
                            React.createElement(StarFilledIcon, null),
                            " Default address")) : null,
                        React.createElement("div", { className: "user-account-item-actions" },
                            React.createElement(RadixButton, { className: "user-account-inline-button", onClick: function () { return handleOpenAddressEditor(addressId); } },
                                React.createElement(Pencil2Icon, null),
                                " Edit"),
                            !defaultAddress ? (React.createElement(RadixButton, { className: "user-account-inline-button", onClick: function () { return handleSetAddressAsDefault(addressId); }, disabled: Boolean(defaultAddressActionId) },
                                React.createElement(StarIcon, null),
                                " ",
                                defaultAddressActionId === addressId ? "Updating..." : "Set as default")) : null,
                            React.createElement(RadixButton, { className: "user-account-inline-button user-account-inline-button--danger", onClick: function () { return openDeleteModal({ type: "address", id: addressId, deleteText: "Are you sure you want to delete this address?" }); } },
                                React.createElement(DeleteIcon, null),
                                " Delete"))));
                }))) : (React.createElement("p", { className: "user-account-empty-copy" }, "No saved addresses yet."))),
                supportsSavedPaymentMethods ? (React.createElement(AccountAccordion, { icon: React.createElement("span", { className: "section-icon" },
                        React.createElement(LockClosedIcon, null)), title: "Saved payment method", isExpanded: expandedSections.payments, onToggle: function () { return toggleSection("payments"); }, disabled: !hasSavedPaymentMethods }, hasSavedPaymentMethods ? (React.createElement("ul", { className: "user-account-list" }, savedCardsForProcessor.map(function (card) {
                    var _a;
                    return (React.createElement("li", { key: String(card.id), className: "user-account-list-item" },
                        React.createElement("p", { className: "user-account-list-item-title" }, (_a = card.friendly_name) !== null && _a !== void 0 ? _a : "Saved card"),
                        React.createElement("div", { className: "user-account-item-actions" },
                            React.createElement(RadixButton, { className: "user-account-inline-button user-account-inline-button--danger", onClick: function () { var _a; return openDeleteModal({ type: "card", id: String((_a = card.id) !== null && _a !== void 0 ? _a : ""), deleteText: "Are you sure you want to delete this payment method?" }); } },
                                React.createElement(DeleteIcon, null),
                                " Delete"))));
                }))) : (React.createElement("p", { className: "user-account-empty-copy" }, "No saved payment methods yet.")))) : null)),
        React.createElement(UserAccountManagementFlyOut, { open: isAccountManagementOpen, onOpenChange: handleAccountManagementOpenChange, onSubmit: handleAccountDetailsUpdate, defaultValues: accountManagementDefaultValues, isSubmitting: isSubmittingAccountDetails, onDeleteAccount: handleDeleteAccount, isDeletingAccount: isDeletingAccount }),
        React.createElement(EditAddressFlyOut, { open: editAddressFlyoutIsOpen, onOpenChange: handleAddressFlyoutOpenChange, onSubmit: handleAddressUpdate, defaultValues: editAddressDefaultValues, isSubmitting: isSubmittingAddress }),
        React.createElement(OrderReviewFlyOut, { open: isOrderReviewOpen, onOpenChange: handleOrderFlyOutOpenChange, order: selectedOrder, onRepeatOrder: handleRepeatOrder, isRepeating: Boolean(isRepeatingOrder) }),
        React.createElement(RadixAlertDialogue, { open: deleteConfirmationModalIsOpen, description: deleteConfirmationText, onOpenChange: setDeleteConfirmationModalIsOpen, actionText: React.createElement("span", null,
                React.createElement(DeleteIcon, null),
                " Delete"), title: "Are you sure?", actionButtonClassName: "user-account-inline-button--danger", showCloseButton: true, closeButtonLabel: "Close delete confirmation", onAction: handleDeleteConfirmed })));
};
